import { render, staticRenderFns } from "./Debitors.vue?vue&type=template&id=087727f4&scoped=true&"
import script from "./Debitors.vue?vue&type=script&lang=ts&"
export * from "./Debitors.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087727f4",
  null
  
)

export default component.exports